import { AxiosError, AxiosResponse } from 'axios'
import { enqueueSnackbar } from 'notistack'

export interface APICustomResponse<T> {
    success: boolean
    data?: T
    error?: any
}

export const showSuccessToster = <T>(
    response: AxiosResponse<T>,
    message?: string,
): void => {
    console.log('response', response)
    if (response.status >= 200 && response.status < 300) {
        const successMessage =
            message || (response.data as any)?.displayMessage || ''
        console.log('successMessage', successMessage)

        enqueueSnackbar(successMessage, { variant: 'success' })
    } else {
        throw new Error('Error')
    }
}

export const showErrorToster = <T>(
    err: AxiosError<T>,
    message?: string,
): void => {
    const errorMessage =
        message ||
        (err?.response?.data as any)?.displayMessage ||
        'An error occurred'
    enqueueSnackbar(errorMessage, { variant: 'error' })
}

// Recursive template finder
export const findTemplateByName = (list: any[], name: string): any => {
    for (const item of list) {
        if (item.name?.trim() === name.trim()) return item
        if (item.subEntityTypes?.length) {
            const result = findTemplateByName(item.subEntityTypes, name)
            if (result) return result
        }
    }
    return null
}
